import { FC } from "react";
import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import GuestSelectFieldWeb from "./layouts/GuestSelectField.web";
import GuestSelectFieldMob from "./layouts/GuestSelectField.mob";

const GuestSelectFieldComponent = withConditionalComponent(GuestSelectFieldWeb, GuestSelectFieldMob);

export type GuestSelectOption = { value: string; label: string };

export type GuestSelectFieldProps = {
  value?: string;
  onChange?: (value: string) => void;
  label?: string;
  placeholder?: string;
  options?: GuestSelectOption[];
  showSearch?: boolean;
};

const GuestSelectField: FC<GuestSelectFieldProps> = (props) => {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return <GuestSelectFieldComponent trigger={isLargeScreen} props={props} />;
};

export default GuestSelectField;
